import client from "api/client";
import type { UserCardApi } from "api/models/card";


const base = "/admin/card";
const card = {
	all: (userId: number, profileId: number) => client.post<UserCardApi[]>(base + "/all", { userId, profileId }),
	delete: (userId: number, profileId: number, cardId: number) => client.post<boolean>(base + "/delete", { userId, profileId, cardId }),
	setDefault: (userId: number, profileId: number, cardId: number) => client.post<UserCardApi[]>(base + "/default", { userId, profileId, cardId })
};

export default card;